import { NumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/NumberValue';
import { LocationPickerButton } from 'elements/minute/sidebar/sidebarComponents/complex/LocationPickerButton';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { useContext, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { useUpdateEffect } from 'usehooks-ts';

export interface InitialPositionData {
    lat: number;
    lng: number;
    zoom: number;
}

interface Props {
    className?: string;
    initialPosition: InitialPositionData;
    onChange: (data: InitialPositionData) => void;
}

export const InitialPosition = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const mapRef = ctxEdit.mapRef?.current;

    const [initial, setInitial] = useState<InitialPositionData>({
        lat: props.initialPosition.lat,
        lng: props.initialPosition.lng,
        zoom: props.initialPosition.zoom
    });

    useUpdateEffect(() => {
        props.onChange(initial);
    }, [initial]);

    return (
        <>
            <SidebarSectionRow title="Zoom">
                <NumberValue
                    value={initial.zoom}
                    onChange={(e) => {
                        setInitial((i) => ({ ...i, zoom: e }));
                    }}
                />
            </SidebarSectionRow>
            <SidebarSectionRow title="Center">
                <LocationPickerButton
                    coordinate={{ lat: initial.lat, lng: initial.lng }}
                    onChange={(value) => {
                        setInitial((curr) => ({
                            ...curr,
                            ...value,
                            zoom: mapRef?.getZoom() ?? initial.zoom
                        }));
                    }}
                />
            </SidebarSectionRow>
        </>
    );
};
